import { render, staticRenderFns } from "./BidPlacedMessage.vue?vue&type=template&id=32dca829&scoped=true&"
import script from "./BidPlacedMessage.vue?vue&type=script&lang=js&"
export * from "./BidPlacedMessage.vue?vue&type=script&lang=js&"
import style0 from "./BidPlacedMessage.vue?vue&type=style&index=0&id=32dca829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dca829",
  null
  
)

export default component.exports